import React from "react";
import { motion } from "framer-motion";
import styles from "./index.module.css";
import scannerImage from "../../../layout/assets/barcode_reader_front.png";
import printerImage from "../../../layout/assets/receiptI_printer_front.png";
import mouseImage from "../../../layout/assets/mouse_front.png";

const CATEGORIES = [
  {
    title: "Scanners",
    description:
      "Fast, accurate barcode scanning built for busy counters and long shifts.",
    image: scannerImage,
  },
  {
    title: "Printers",
    description:
      "Reliable receipt and label printers that keep checkout moving without delays. We offer a wide range of printers to suit your needs.",
    image: printerImage,
  },
  {
    title: "Peripherals",
    description:
      "Essential POS gear to complete your setup from drawers to displays.",
    image: mouseImage,
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 36 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
      delay: index * 0.12,
    },
  }),
};

const BottomContainer = () => {
  return (
    <section className={styles.section}>
      <div className={styles.grid}>
        {CATEGORIES.map((category, index) => (
          <motion.article
            className={styles.card}
            key={category.title}
            custom={index}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.25 }}
            whileHover={{ y: -6 }}
            transition={{ type: "spring", stiffness: 320, damping: 24 }}
          >
            <div className={styles.imageWrap}>
              <img
                className={styles.image}
                src={category.image}
                alt={category.title}
              />
            </div>
            <h3 className={styles.title}>{category.title}</h3>
            <p className={styles.description}>{category.description}</p>
            <a className={styles.link} href="#catalog">
              Explore Category <span aria-hidden="true">→</span>
            </a>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default BottomContainer;
